<app-auth-layout>
  <form
    class="form-container"
    [class.fade]="isTransitioning"
    [formGroup]="forgotCodeForm"
    (ngSubmit)="step() === steps.CreateNewPin ? goToNextStep(steps.ConfirmNewPin) : null"
  >
    @if (step() === steps.CreateNewPin) {
      <div class="title-container code">
        <h1 class="title"> {{ 'WebApp.v1.Auth.ForgotCode.Title' | translate }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.ForgotCode.SubTitle' | translate }}</p>
      </div>

      <div class="error">{{ errorMessage | translate }}</div>

      @if (forgotCodeEmailValidationErrorSignal()) {
        <div class="error">{{ forgotCodeEmailValidationErrorSignal()! }}</div>
      }

      <app-pin-code [disabled]="forgotCodeForm.disabled" class="pin-code" (pinChanged)="updatePincode($event)"></app-pin-code>
    }

    @if (step() === steps.ConfirmNewPin || step() === steps.Loading || step() === steps.Done) {
      <div class="title-container code">
        <h1 class="title">
          @if (step() === steps.ConfirmNewPin) {
            <ng-container>{{ 'WebApp.v1.Auth.ForgotCode.RepeatYourCode' | translate }}</ng-container>
          } @else if (step() === steps.Done) {
            <ng-container>{{ 'WebApp.v1.Auth.ForgotCode.NewPinCreated' | translate }}</ng-container>
          }
        </h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.ForgotCode.ReEnterYourCode' | translate }}</p>
      </div>

      <div class="error">{{ errorMessage | translate }}</div>

      @if (newPasswordValidationErrorSignal()) {
        <div class="error">{{ newPasswordValidationErrorSignal()! }}</div>
      }

      <app-pin-code class="pin-code" [disabled]="step() === steps.Done" (pinChanged)="updatePincode($event)"></app-pin-code>

      @if (step() === steps.Loading) {
        <app-loader></app-loader>
      }

      @if (step() === steps.Done) {
        <i class="fa-solid fa-check big green"></i>
      }

      @if (step() === steps.ConfirmNewPin) {
        <div class="actions">
          <div class="back" (click)="goToCreateNewPin()">
            <i class="fa-solid fa-chevron-left"></i>{{ 'WebApp.v1.Shared.Buttons.Back' | translate }}
          </div>
        </div>
      }
    }
  </form>
</app-auth-layout>
